export const CAMPAIGNS_GROUPS_REPORT_ID = 'campaigns-groups';
